import React, { useState, useEffect, useContext } from 'react';
import axios from "@common/axios";
import { FolderOutlined } from "@mui/icons-material";
import useCurrentConcept from "@hooks/useCurrentConcept";
import { UserContext } from "@context/UserContext";
import { NavigationContext } from "@common/context/NavigationContext";
import ListGroup from "@common/ListGroup";
import ListItem from "@common/ListItem";

const Bookmarks = props => {
    const {ariaLabelledby} = props;
    const { user } = useContext(UserContext);
    const { setNavVisible } = useContext(NavigationContext);
    const { loadCurrentConcept } = useCurrentConcept();
    const [linkGroups, setLinkGroups] = useState([]);

    const getBookmarks = () => {
        axios.get('/web/ui/linking/findUserLinkGroups')
            .then(response => {
                setLinkGroups(response.data.filter(linkGroup => linkGroup.linkUrls.length > 0));
            });
    }

    useEffect(() => {
        getBookmarks();

        window.addEventListener('bookmarkUpdated', getBookmarks);
        return () => {
            window.removeEventListener('bookmarkUpdated', getBookmarks);
        }
    }, []);

    return (
        <ul className='ch-list ch-nav-group' key={'bookmarksNav'} aria-labelledby={ariaLabelledby}>
            {linkGroups.length === 0 &&
                <li className={'ch-list-item'}>No bookmarks</li>
            }
            {linkGroups.length > 0 &&
                linkGroups.map(linkGroup => {
                    return (
                        <ListGroup id={'bookmarks-notifications-control-' + linkGroup.linkGroupId} isDisclosureItem={true}  key={'nav-' + linkGroup.linkGroupId} title={linkGroup.name} icon={<FolderOutlined />} disabled={linkGroup.linkUrls.length == 0} startOpen={false}>
                            {linkGroup.linkUrls.map(link => {
                                const onClick = (e) => {
                                    if (e.type == 'click' || (e.type == 'keydown' && e.code == 'Enter')) {
                                        if (link.syllabusId === user.syllabusId) {
                                            loadCurrentConcept(link.conceptId, link.tabBean !== undefined ? link.urlHash : null);
                                            setNavVisible(false);

                                            if (globalReactFunctions && globalReactFunctions.handleTitleNavMenuClose) {
                                                globalReactFunctions.handleTitleNavMenuClose();
                                            }
                                        } else {
                                            setNavVisible(false);
                                            window.location.href = link.url;
                                        }
                                    }
                                }

                                return (
                                    <ListItem isDisclosureItem={true} className={'ch-link'} key={'nav-' + linkGroup.linkGroupId + '' + link.linkUrlId} onClick={onClick}>
                                        {link.name}
                                    </ListItem>
                                )
                            })}
                        </ListGroup>
                    )
                })
            }
        </ul>
    );
}

export default Bookmarks;
